import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics';

import { OBJECT_SIDEBAR_CONTROL_METRIC } from './perf.config';
import type { ObjectSidebarControlProps } from './ObjectSidebarControl';

export {
	useMoreActionsObjectSidebarTour,
	MoreActionsObjectSidebarTourSteps,
} from './useMoreActionsObjectSidebarTour';
export {
	useMoreActionsObjectSidebarTourState,
	useMoreActionsObjectSidebarTourActions,
} from './useMoreActionsObjectSidebarTourState';

export { CommentPanelButton as CommentIconWithUnread } from './sidebar-buttons/CommentPanelButton';

export { OBJECT_SIDEBAR_TOUR_TARGETS } from './objectSidebarTourTargets';
export { ObjectSidebarPushPlaceholder } from './ObjectSidebarPushPlaceholder';

export const EditorObjectSidebarPanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorObjectSidebarPanel" */ './EditorObjectSidebarPanel'
			)
		).EditorObjectSidebarPanel,
});

export const ObjectSidebarPanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarPanel" */ './ObjectSidebarPanelWrapper'
			)
		).ObjectSidebarPanelWrapper,
});

const ObjectSidebarControlLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ObjectSidebarControl" */ './ObjectSidebarControl'))
			.ObjectSidebarControl,
});

export const ObjectSidebarControl = (props: ObjectSidebarControlProps) => (
	<>
		<PageSegmentLoadStart metric={OBJECT_SIDEBAR_CONTROL_METRIC} />
		<ObjectSidebarControlLoader {...props} />
	</>
);
